import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import image from "../assets/Fahim-Shariar.jpg";
import { Link } from "react-scroll";
import { TypeAnimation } from "react-type-animation";

const Home = () => {
  return (
    <div
      name="home"
      className="w-full h-screen bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col md:flex-row items-center justify-center h-full px-4">
        <div className="flex flex-col justify-between">
          <h2 className="text-4xl sm:text-7xl font-bold text-white mt-20">
            I'm Fahim Shariar
          </h2>
          <TypeAnimation
            sequence={[
              "Full-Stack Developer",
              1000,
              "MERN Stack Developer",
              1000,
              "Front-End Developer",
              1000,
              "React Developer",
              1000,
              "JavaScript Developer",
              1000,
            ]}
            speed={50}
            style={{ color: "#06B6D4", fontSize: "1.875rem", fontWeight: 700 }}
            repeat={Infinity}
          />
          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <HiArrowNarrowRight className="ml-1" />
              </span>
            </Link>
          </div>
        </div>
        <div className="mt-8">
          <img
            src={image}
            alt="my profile"
            className="rounded-2xl mx-auto w-full md:w-4/6"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
